import { DashboardCount, GetAllThumbnail, CompanySitedetails } from "../Constants/DashboardCount"

// initial state
const initialState = {
    dashboardData: [],
    thumbnail: [],
    companysite: []
}


export const DashboardReducers = (state = initialState, { type, payload }) => {

    switch (type) {

        case DashboardCount.GET_DASHBOARDCOUNT:
            return { ...state, dashboardData: payload.data };
        case GetAllThumbnail.GET_ALLTHUMBNAIL:
            return { ...state, thumbnail: payload.allThumbnailList }
        case CompanySitedetails.GET_COMPANYSITEDETAILS:
            return { ...state, companysite: payload.data }
        default:
            return state;
    }
};